import React from 'react';
import ReactApexChart from 'react-apexcharts';
import styled from 'styled-components';
import { Text } from '../../Global/Atomics/Text';
import Theme from '../../../styles/Theme/Theme';

const SemiCircle = (props) => {
  const value = props?.data ?? 0;
  let color;
  let label;
  let trackColor;

  if (value >= 0 && value <= 25) {
    color = Theme.color['critical-base'];
    label = 'Bad';
    trackColor = Theme.color['critical-light'];
  } else if (value >= 26 && value <= 60) {
    color = Theme.color['medium-base']; 
    label = 'Medium';
    trackColor = Theme.color['medium-light'];
  } else {
    color = Theme.color['low-base']; 
    label = 'Good';
    trackColor = Theme.color['low-light'];
  }

  const state = {
    series: [value],
    options: {
      colors: [color],
      chart: {
        type: 'radialBar',
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          track: {
            background: trackColor,
            strokeWidth: '100%'
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: false,
              fontSize: '0.6vw',
              fontWeight: 'bold',
              offsetY: -100
            },
          },
          hollow: {
            margin: 0,
            size: "70%",
          },
        },
      },
      stroke: {
        lineCap: 'round'
      },
    },
  };

  const labelStyle = {
    fontSize: '0.8vw',
    display: "flex",
    flexDirection: 'column',
    alignItems: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translateX(-50%)'
  };

  return (
    <div style={{ position: 'relative', width: "90%", height: "90%", display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <div id="chart" style={{width: 'inherit'}}>
        <ReactApexChart
          options={state.options}
          series={state.series}
          type="radialBar"
        />
      </div>
      <div style={labelStyle}>
        <Text color={Theme.color['black-1']} fontSize="text_lg" fontWeight={Theme.typography.weight.bold}>{value}%</Text>
        <Text color={Theme.color['coolgray-10']} fontSize="text_md" fontWeight={Theme.typography.weight.regular}>{label}</Text>
      </div>
    </div>
  );
};

export default SemiCircle;